import NewWallet from "../../../../components/@wallets/wallets/NewWallet";
import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WalletNewPage() {

    return NewWallet({
        routeType: routeTypes.admin
    })
}       